import { render } from "./StoryFormCard.vue?vue&type=template&id=5d96a2f8&ts=true"
import script from "./StoryFormCard.vue?vue&type=script&lang=ts"
export * from "./StoryFormCard.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/Chirbou/digithia/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__